/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { RouteConfig } from "vue-router";

export const loginRoute: RouteConfig[] = [
    {
        component: () => import(/* webpackChunkName: "login" */ "@/views/Login/LoginView.vue"),
        path: '/login',
    },
    {
        component: () => import(/* webpackChunkName: "login" */ "@/views/Login/LandingPageView.vue"),
        path: '/login/:landingPageId',
        props: true,
    },
];
